<template>
  <div class="enrollInputImgWrapper">
    <input ref="imageInput" type="file" hidden v-on:change="onChangeImages">
    <img class="enrollInputImg" v-bind:src="imageUrl">
    <div class="overlayImgWrapper">
      <img class="overlayImg" v-bind:src="iconUrl" v-on:click="onClickIcon">
    </div>
  </div>
</template>

<script>

export default {
  props: {
    answerCount: Number
  },
  data () {
    return {
      isImageSet: false,
      imageUrl: '',
      iconUrl: require('@/assets/img/add_image_icon.png')
    }
  },
  methods: {
    onClickIcon () {
      if(!this.isImageSet) {
        this.$refs.imageInput.click()
      }else{
        this.iconUrl = require('@/assets/img/add_image_icon.png')
        this.setCanvas(require('@/assets/img/question_answer_default_img.png'), false)
        this.setImageInfoStore(this.answerCount, null)
        this.$refs.imageInput.value = null
      }
    },
    onChangeImages (e) {
      let pathPoint = e.target.files[0].name.lastIndexOf('.')
      let fileType = e.target.files[0].name.substring(pathPoint + 1, e.target.files[0].name.length).toLowerCase()

      if (fileType === 'jpg' || fileType === 'jpeg' || fileType === 'gif' || fileType === 'png' || fileType === 'bmp' || fileType === '') {
        const file = e.target.files[0]
        this.setCanvas(file, true)
        this.setImageInfoStore(this.answerCount, file)
      }else {
        this.setCanvas(require('@/assets/img/question_answer_default_img.png'), false)
        this.setImageInfoStore(this.answerCount, null)
        alert('이미지 파일을 선택 해 주세요.')
      }
    },
    setCanvas (fileOrImageUrl, isImageSet) {
      // 캔버스에 이미지 셋팅
      this.imageUrl = fileOrImageUrl instanceof File ? URL.createObjectURL(fileOrImageUrl) : fileOrImageUrl
      this.isImageSet = isImageSet
    },
    setImageInfoStore (adChoiceNumber, file) {
      // 선택지 이미지
      this.$store.commit('setEnrollStateValue', {type: 'answerImg', adChoiceNumber: adChoiceNumber, value: {choiceImg: file}})
      this.$store.commit('setAdUiStateValue', {type: 'answer' + adChoiceNumber + 'Img', value: file != null ? URL.createObjectURL(file) : null})
    }
  },
  created: function () {
    // 기존에 EnrollState에 지정된 이미지(url)이 있을 경우 이미지 불러옴
    let beforeAnswerImg = this.$store.getters.getEnrollStateArrayValue('answerImg', {index: this.answerCount - 1, valueName: 'choiceImg'})
    beforeAnswerImg != null ? this.setCanvas(beforeAnswerImg, true) : this.setCanvas(require('@/assets/img/question_answer_default_img.png'), false)
  },
  mounted: function () {
    this.$store.watch(() => this.$store.getters.getRemoveWatchTrigger, value => {
      // 답변 삭제 등으로 답변값이 변경되었을 때 발동
      // 캔버스 변경
      let changedImg = this.$store.getters.getEnrollStateArrayValue('answerImg', {index: this.answerCount - 1, valueName: 'choiceImg'})
      changedImg != null ? this.setCanvas(changedImg, true) : this.setCanvas(require('@/assets/img/question_answer_default_img.png'), false)
      // 핸드폰 ui 변경
      this.$store.commit('setAdUiStateValue', {type: 'answer' + this.answerCount + 'Img', value: changedImg instanceof File ? URL.createObjectURL(changedImg) : changedImg})
    })
  },
  watch: {
    isImageSet: function () {
      this.iconUrl = this.isImageSet ? require('@/assets/img/remove_image_icon.png') : require('@/assets/img/add_image_icon.png')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type='text']{
  padding: 0;
  font-size: 22px;
  width: 100%;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
  outline: none;
}

span {
  font-size: 12px;
}

.enrollInputImgWrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.enrollInputImg{
  width: 100%;
  height: 100%;
}

.overlayImgWrapper{
  position: absolute;
  top: calc(100% - 18px);
  left: calc(100% - 18px);
}

.overlayImg{
  cursor: pointer;
  width: 24px;
  height: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/board/elements/enrollInputImgAnswer.vue